import React from "react";
import {
  Badge,
  Box,
  Button,
  ButtonGroup,
  HStack,
  Text,
  VStack,
  useColorModeValue,
} from "@chakra-ui/react";

export const getRuntimeFieldLabel = (field) =>
  String(field?.label || "")
    .replace(/\s*[-–]\s*replace with exact source wording\.?/i, "")
    .replace(/\s*replace with exact source wording\.?/i, "")
    .trim();

const RiskReviewQuestionCard = ({ field, value, onChange, disabled, error, index }) => {
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.200");
  const bg = useColorModeValue("white", "gray.800");
  const selectedBg = useColorModeValue("blue.50", "whiteAlpha.100");
  const riskBg = useColorModeValue("orange.50", "orange.900");
  const muted = useColorModeValue("gray.600", "gray.400");
  const triggerValue = field.riskConfig?.triggerValue;
  const isTriggered =
    field.riskConfig?.enabled &&
    value !== undefined &&
    value !== "" &&
    value === triggerValue;

  return (
    <Box
      bg={isTriggered ? riskBg : bg}
      borderWidth="1px"
      borderColor={isTriggered ? "orange.300" : error ? "red.400" : borderColor}
      borderRadius="lg"
      p={4}
      transition="border-color 160ms ease, background 160ms ease"
    >
      <VStack align="stretch" spacing={3}>
        <HStack align="flex-start" justify="space-between" spacing={4}>
          <HStack align="flex-start" spacing={3}>
            <Text color={muted} fontSize="xs" fontWeight="bold" minW="28px">
              {String(index + 1).padStart(2, "0")}
            </Text>
            <Box>
              <Text fontWeight="semibold">{getRuntimeFieldLabel(field)}</Text>
              {field.description ? (
                <Text color={muted} fontSize="sm" mt={1}>
                  {field.description}
                </Text>
              ) : null}
            </Box>
          </HStack>
          {field.riskConfig?.triggerCode ? (
            <Badge colorScheme={isTriggered ? "orange" : "gray"} borderRadius="full" textTransform="none">
              Trigger {field.riskConfig.triggerCode}
            </Badge>
          ) : null}
        </HStack>

        <HStack justify="space-between" wrap="wrap">
          <Text color={isTriggered ? "orange.700" : muted} _dark={{ color: isTriggered ? "orange.200" : "gray.400" }} fontSize="sm">
            {isTriggered
              ? `${field.riskConfig?.severity || "Risk"} risk requires additional review.`
              : "No additional risk triggered"}
          </Text>
          <ButtonGroup isAttached size="sm" variant="outline">
            <Button
              bg={value === true ? selectedBg : undefined}
              colorScheme={value === true ? "blue" : "gray"}
              variant={value === true ? "solid" : "outline"}
              isDisabled={disabled}
              onClick={() => onChange(true)}
            >
              Yes
            </Button>
            <Button
              bg={value === false ? selectedBg : undefined}
              colorScheme={value === false ? "blue" : "gray"}
              variant={value === false ? "solid" : "outline"}
              isDisabled={disabled}
              onClick={() => onChange(false)}
            >
              No
            </Button>
          </ButtonGroup>
        </HStack>
        {error?.message ? (
          <Text color="red.500" fontSize="sm">
            {error.message}
          </Text>
        ) : null}
      </VStack>
    </Box>
  );
};

export default RiskReviewQuestionCard;
